import React, { useState, useEffect, useRef , useContext } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import SubNav from '../../PageComponents/Nav/SubNav'
import helper from '../../Services/helper';
import InternalMovements from './InternalMovements';
import InternalMovement from './InternalMovement';
//import Admin from '../AdministrationOld/administrationOld';
import RecalculateAvgPrice from '../../components/Tools/RecalculateAvgPrice.js';
import UserPermissionContext from '../Context/UserPermissionContext';
import Sales from '../Sales/Sales.js';
import ItemSaleCalculate from './ItemSaleCalculate.js';
import ItemSalesCalculate from './ItemSalesCalculate.js';
import SalesDrafts from './SalesDrafts.js';
import SaleDraft from './SaleDraft.js';


const links = [
     {path:"features/internal-movements", name:helper().translate("INTERNAL_MOVEMENT"), icon:"fas fa-file-invoice-dollar mr-2", component: InternalMovements, type:"menu" },
    {path:"features/internal-movement/new/:id", name:"Urdheresa financiare id", icon:"fas fa-money-bill mr-2", component: InternalMovement, type:"link"},
    {path:"features/sale-items-calculate/:id", name:"EditSaleCalculateItems", icon:"fas fa-comments-dollar mr-2", component: ItemSaleCalculate, type:"link"},
    {path:"features/sales-item-calculate", name:helper().translate("ITEMS_CALCULATE") , icon:"fas fa-pen mr-2", component: ItemSalesCalculate, type:"menu"},
    {path:"features/sale-draft/:id", name:"EditSaleDraft", icon:"fas fa-comments-dollar mr-2", component: SaleDraft, type:"link"},
    {path:"features/sales-drafts", name:helper().translate("SALES_DRAFT") , icon:"fas fa-pen mr-2", component: SalesDrafts, type:"menu"},
    {path:'features/recalculation', name:'Rikalkulimi', icon: "fas fa-fw fa-wrench mr-2", component: RecalculateAvgPrice,  type:"menu"},
]



const Features = (props) => {
    
    const {userPermission} = useContext(UserPermissionContext);
    if(userPermission?.find((f)=> f.moduleName === 'INTERNAL_MOVEMENT')?.allowView === 0){
        links[0].disabled = true
    }
    
    return (
        <div className="d-flex">
        <div className="p-0 position-relative sub-menu">
            <SubNav links={links} />
        </div>
        <div className="w-100 overflow-auto pr-0">
            {props?.location?.pathname === '/features'  && userPermission?.find((f)=> f.moduleName === 'INTERNAL_MOVEMENT')?.allowView === 1 ?  <InternalMovements /> : ""}
            <Router>
                <Switch>
                    {links.map((link)=>{
                        return <Route path={`/${link.path}`} component={link.component} />
                    })}
                </Switch>
            </Router>
        </div>
    </div> 
   
    )
}

export default Features
